export default "__VITE_ASSET__zHU$GgjN__"